import { render, staticRenderFns } from "./recovery-prompt.vue?vue&type=template&id=13fd5f7f&scoped=true"
import script from "./recovery-prompt.vue?vue&type=script&lang=js"
export * from "./recovery-prompt.vue?vue&type=script&lang=js"
import style0 from "./recovery-prompt.vue?vue&type=style&index=0&id=13fd5f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd5f7f",
  null
  
)

export default component.exports